
$(document).ready(function() {
  $('ul.tabs').each(function(){
    var $active, $content, $links = $(this).find('a');
    $active = $($links.filter('[href="'+location.hash+'"]')[0] || $links[0]);
    $active.addClass('active');
    $content = $($active[0].hash);

    $links.not($active).each(function () {
      $(this.hash).hide();
    });

    $(this).on('click', 'a', function(e){
      $active.removeClass('active');
      $content.hide();
      $active = $(this);
      $content = $(this.hash);
      $active.addClass('active');
      $content.show();
      e.preventDefault();
    });
  });
  
  // $(".single-option-selector[data-option='option1']").change(function(){
  //   $("#sample-colour").val($(".single-option-selector[data-option='option1']").children("option:selected").val());
  //   setTimeout(function(){ $("#sample-sku").val($("p.sku").text()); }, 100);
  //   setTimeout(function(){ $(".variant_colour span").text($(".single-option-selector[data-option='option1']").children("option:selected").val()); }, 100);
  //   setTimeout(getSampleImage, 100);
  // });
});

document.querySelectorAll('.swatch__option input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', event => {
        if (event.target.checked) {
            const parentOption = event.target.closest('.swatch__option'); // Get the parent element
            const selectedValue = event.target.value; // Get the radio button's value
             $("#sample-colour").val(selectedValue);
               setTimeout(function(){ $("#sample-sku").val($("p.sku").text()); 
                 getSampleImage()                 
            }, 100);

        }
    });
});


function getSampleImage() {
  var img = $(".product-gallery__image.is-selected").find("img");
  var len = img.length;
  if( len > 0 ){
    var imgSrc = img.first().attr("src");
    $("#sample_product_image").val(imgSrc);
    //console.log("Image found: " + imgSrc);
  } else {
    //console.log("No image found");
  }
}

/* HC - Adjust limespot layout on product page - 14 April 21 */
window.whenExist = (selector, callback) => {
  const observer = new MutationObserver((mutationsList, observer) => {
    for(const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if ( node instanceof Element && (node.matches(selector) || node.querySelector(selector)) ) {
            callback(node);
            observer.disconnect();
          }
        });
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
};